import React from 'react';
import { connect } from 'react-redux';
import { DBTextArea, ObjectiveFlag, DBTextFieldObjective, AddButton } from '_components';
import { PatientCareCenterNoteSection } from 'PatientCareCenter/Note';
import styles from './Common.module.css'
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
class ROMHandTemplate extends React.Component {

    updateValue(colName){
        this.props.updateDefaultObjHandWFL(this.props.noteType, colName, this.props.pk);
    }


    render() {
        return (
            <>
                <PatientCareCenterNoteSection id='obj_hand' name='Hand and Wrist Template' level={2}>
                    <div className={styles.row_hand}>
                        <div className={styles.center}>
                            AROM
                        </div>
                    </div>
                    <div className={styles.row_hand}>
                        <div className={styles.flag}></div>
                        <div className={styles.rowTitle}></div>
                        <div className={styles.hand3_column}>
                            MC
                        </div>
                        <div className={styles.hand3_column_shaded}>
                            PIP
                        </div>
                        <div className={styles.hand3_column}>
                            DIP
                        </div>
                    </div>
                    <div className={styles.row_hand}>
                        <div className={styles.flag}></div>
                        <div className={styles.rowTitle}></div>
                        <div className={styles.hand6_column}>
                            R
                        </div>

                        <div className={styles.hand6_column}>
                            L
                        </div>

                        <div className={styles.hand6_column_shaded}>
                            R
                        </div>
                        <div className={styles.hand6_column_shaded}>
                            L
                        </div>
                        <div className={styles.hand6_column}>
                            R
                        </div>
                        <div className={styles.hand6_column}>
                            L
                        </div>
                    </div>
                    
                    <div className={styles.row_hand}>
                        <div className={styles.flag}></div>
                        <div className={styles.rowTitle}></div>
                        <div className={styles.hand12_column}>
                            Ext
                        </div>
                        <label className={styles.slash}>/</label>
                        <div className={styles.hand12_column}>
                            Flex
                        </div>
                        <div className={styles.hand12_column}>
                            Ext
                        </div>
                        <label className={styles.slash}>/</label>
                        <div className={styles.hand12_column}>
                            Flex
                        </div>
                        <div className={styles.hand12_column_shaded}>
                            Ext
                        </div>
                        <label className={styles.slash_shaded}>/</label>
                        <div className={styles.hand12_column_shaded}>
                            Flex
                        </div>
                        <div className={styles.hand12_column_shaded}>
                            Ext
                        </div>
                        <label className={styles.slash_shaded}>/</label>
                        <div className={styles.hand12_column_shaded}>
                            Flex
                        </div>
                        <div className={styles.hand12_column}>
                            Ext
                        </div>
                        <label className={styles.slash}>/</label>
                        <div className={styles.hand12_column}>
                            Flex
                        </div>
                        <div className={styles.hand12_column}>
                            Ext
                        </div>
                        <label className={styles.slash}>/</label>
                        <div className={styles.hand12_column}>
                            Flex
                        </div>
                    </div>
                    <div className={styles.row_hand}>
                        <div className={styles.flag}></div>
                        <div className={styles.rowTitle}></div>
                        <div className={styles.hand12_column}>
                        <AddButton size='extra-small' title={'WFL'} onClick={() => this.updateValue('AROMMCREXT')} />
                        </div>
                        <label className={styles.slash}>/</label>
                        <div className={styles.hand12_column}>
                        <AddButton size='extra-small' title={'WFL'} onClick={() => this.updateValue('AROMMCRFLEX')} />
                        </div>
                        <div className={styles.hand12_column}>
                        <AddButton size='extra-small' title={'WFL'} onClick={() => this.updateValue('AROMMCLEXT')} />
                        </div>
                        <label className={styles.slash}>/</label>
                        <div className={styles.hand12_column}>
                        <AddButton size='extra-small' title={'WFL'} onClick={() => this.updateValue('AROMMCLFLEX')} />
                        </div>
                        <div className={styles.hand12_column_shaded}>
                        <AddButton size='extra-small' title={'WFL'} onClick={() => this.updateValue('AROMPIPREXT')} />
                        </div>
                        <label className={styles.slash_shaded}>/</label>
                        <div className={styles.hand12_column_shaded}>
                        <AddButton size='extra-small' title={'WFL'} onClick={() => this.updateValue('AROMPIPRFLEX')} />
                        </div>
                        <div className={styles.hand12_column_shaded}>
                        <AddButton size='extra-small' title={'WFL'} onClick={() => this.updateValue('AROMPIPLEXT')} />
                        </div>
                        <label className={styles.slash_shaded}>/</label>
                        <div className={styles.hand12_column_shaded}>
                        <AddButton size='extra-small' title={'WFL'} onClick={() => this.updateValue('AROMPIPLFLEX')} />
                        </div>
                        <div className={styles.hand12_column}>
                        <AddButton size='extra-small' title={'WFL'} onClick={() => this.updateValue('AROMDIPREXT')} />
                        </div>
                        <label className={styles.slash}>/</label>
                        <div className={styles.hand12_column}>
                        <AddButton size='extra-small' title={'WFL'} onClick={() => this.updateValue('AROMDIPRFLEX')} />
                        </div>
                        <div className={styles.hand12_column}>
                        <AddButton size='extra-small' title={'WFL'} onClick={() => this.updateValue('AROMDIPLEXT')} />
                        </div>
                        <label className={styles.slash}>/</label>
                        <div className={styles.hand12_column}>
                        <AddButton size='extra-small' title={'WFL'} onClick={() => this.updateValue('AROMDIPLFLEX')} />
                        </div>
                    </div>
                    <div className={styles.row_hand}>
                        <ObjectiveFlag className={styles.flag} flagged={this.props.indexAROM} mopno={this.props.mopno} flagText='Index Finger - AROM' />
                        <div className={styles.rowTitle}>
                            Index Finger
                        </div>
                        <div className={styles.hand12_column}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='ROINDEXMCPEXTENSIONAROMR'
                                className={styles.arom_hand}
                                placeholder={this.props.prevIndexMcExtensionAromR}
                            />
                        </div>
                        <label className={styles.slash}>/</label>
                        <div className={styles.hand12_column}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='ROINDEXMCPFLEXIONAROMR'
                                className={styles.arom_hand}
                                placeholder={this.props.prevIndexMcpFlexionAromR}
                            />
                        </div>
                        <div className={styles.hand12_column}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='ROINDEXMCPEXTENSIONAROML'
                                className={styles.arom_hand}
                                placeholder={this.props.prevIndexMcExtensionAromL}
                            />
                        </div>
                        <label className={styles.slash}>/</label>
                        <div className={styles.hand12_column}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='ROINDEXMCPFLEXIONAROML'
                                className={styles.arom_hand}
                                placeholder={this.props.prevIndexMcpFlexionAromL}
                            />
                        </div>

                        <div className={styles.hand12_column_shaded}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='ROINDEXPIPEXTENSIONAROMR'
                                className={styles.arom_hand}
                                placeholder={this.props.prevIndexPipExtensionAromR}
                            />
                        </div>
                        <label className={styles.slash_shaded}>/</label>
                        <div className={styles.hand12_column_shaded}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='ROINDEXPIPFLEXIONAROMR'
                                className={styles.arom_hand}
                                placeholder={this.props.prevIndexPipFlexionAromR}
                            />
                        </div>
                        <div className={styles.hand12_column_shaded}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='ROINDEXPIPEXTENSIONAROML'
                                className={styles.arom_hand}
                                placeholder={this.props.prevIndexPipExtensionAromL}
                            />
                        </div>
                        <label className={styles.slash_shaded}>/</label>
                        <div className={styles.hand12_column_shaded}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='ROINDEXPIPFLEXIONAROML'
                                className={styles.arom_hand}
                                placeholder={this.props.prevIndexPipFlexionAromL}
                            />
                        </div>

                        <div className={styles.hand12_column}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='ROINDEXDIPEXTENSIONAROMR'
                                className={styles.arom_hand}
                                placeholder={this.props.prevIndexDipExtensionAromR}
                            />
                        </div>
                        <label className={styles.slash}>/</label>
                        <div className={styles.hand12_column}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='ROINDEXDIPFLEXIONAROMR'
                                className={styles.arom_hand}
                                placeholder={this.props.prevIndexDipFlexionAromR}
                            />
                        </div>
                        <div className={styles.hand12_column}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='ROINDEXDIPEXTENSIONAROML'
                                className={styles.arom_hand}
                                placeholder={this.props.prevIndexDipExtensionAromL}
                            />
                        </div>
                        <label className={styles.slash}>/</label>
                        <div className={styles.hand12_column}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='ROINDEXDIPFLEXIONAROML'
                                className={styles.arom_hand}
                                placeholder={this.props.prevIndexDipFlexionAromL}
                            />
                        </div>
                    </div>
                    <div className={styles.row_hand}>
                        <ObjectiveFlag className={styles.flag} flagged={this.props.middleAROM} mopno={this.props.mopno} flagText='Middle Finger - AROM' />
                        <div className={styles.rowTitle}>
                            Middle Finger
                        </div>
                        <div className={styles.hand12_column}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='ROMIDDLEMCPEXTENSIONAROMR'
                                className={styles.arom_hand}
                                placeholder={this.props.prevMiddleMcExtensionAromR}
                            />
                        </div>
                        <label className={styles.slash}>/</label>
                        <div className={styles.hand12_column}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='ROMIDDLEMCPFLEXIONAROMR'
                                className={styles.arom_hand}
                                placeholder={this.props.prevMiddleMcpFlexionAromR}
                            />
                        </div>
                        <div className={styles.hand12_column}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='ROMIDDLEMCPEXTENSIONAROML'
                                className={styles.arom_hand}
                                placeholder={this.props.prevMiddleMcExtensionAromL}
                            />
                        </div>
                        <label className={styles.slash}>/</label>
                        <div className={styles.hand12_column}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='ROMIDDLEMCPFLEXIONAROML'
                                className={styles.arom_hand}
                                placeholder={this.props.prevMiddleMcpFlexionAromL}
                            />
                        </div>

                        <div className={styles.hand12_column_shaded}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='ROMIDDLEPIPEXTENSIONAROMR'
                                className={styles.arom_hand}
                                placeholder={this.props.prevMiddlePipExtensionAromR}
                            />
                        </div>
                        <label className={styles.slash_shaded}>/</label>
                        <div className={styles.hand12_column_shaded}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='ROMIDDLEPIPFLEXIONAROMR'
                                className={styles.arom_hand}
                                placeholder={this.props.prevMiddlePipFlexionAromR}
                            />
                        </div>
                        <div className={styles.hand12_column_shaded}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='ROMIDDLEPIPEXTENSIONAROML'
                                className={styles.arom_hand}
                                placeholder={this.props.prevMiddlePipExtensionAromL}
                            />
                        </div>
                        <label className={styles.slash_shaded}>/</label>
                        <div className={styles.hand12_column_shaded}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='ROMIDDLEPIPFLEXIONAROML'
                                className={styles.arom_hand}
                                placeholder={this.props.prevMiddlePipFlexionAromL}
                            />
                        </div>

                        <div className={styles.hand12_column}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='ROMIDDLEDIPEXTENSIONAROMR'
                                placeholder={this.props.prevMiddleDipExtensionAromR}
                                className={styles.arom_hand}
                            />
                        </div>
                        <label className={styles.slash}>/</label>
                        <div className={styles.hand12_column}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='ROMIDDLEDIPFLEXIONAROMR'
                                className={styles.arom_hand}
                                placeholder={this.props.prevMiddleDipFlexionAromR}
                            />
                        </div>
                        <div className={styles.hand12_column}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='ROMIDDLEDIPEXTENSIONAROML'
                                className={styles.arom_hand}
                                placeholder={this.props.prevMiddleDipExtensionAromL}
                            />
                        </div>
                        <label className={styles.slash}>/</label>
                        <div className={styles.hand12_column}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='ROMIDDLEDIPFLEXIONAROML'
                                className={styles.arom_hand}
                                placeholder={this.props.prevMiddleDipFlexionAromL}
                            />
                        </div>
                    </div>
                    <div className={styles.row_hand}>
                        <ObjectiveFlag className={styles.flag} flagged={this.props.ringAROM} mopno={this.props.mopno} flagText='Ring Finger - AROM' />
                        <div className={styles.rowTitle}>
                            Ring Finger
                        </div>
                        <div className={styles.hand12_column}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='RORINGMCPEXTENSIONAROMR'
                                className={styles.arom_hand}
                                placeholder={this.props.prevRingMcExtensionAromR}
                            />
                        </div>
                        <label className={styles.slash}>/</label>
                        <div className={styles.hand12_column}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='RORINGMCPFLEXIONAROMR'
                                className={styles.arom_hand}
                                placeholder={this.props.prevRingMcpFlexionAromR}
                            />
                        </div>
                        <div className={styles.hand12_column}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='RORINGMCPEXTENSIONAROML'
                                className={styles.arom_hand}
                                placeholder={this.props.prevRingMcExtensionAromL}
                            />
                        </div>
                        <label className={styles.slash}>/</label>
                        <div className={styles.hand12_column}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='RORINGMCPFLEXIONAROML'
                                className={styles.arom_hand}
                                placeholder={this.props.prevRingMcpFlexionAromL}
                            />
                        </div>

                        <div className={styles.hand12_column_shaded}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='RORINGPIPEXTENSIONAROMR'
                                className={styles.arom_hand}
                                placeholder={this.props.prevRingPipExtensionAromR}
                            />
                        </div>
                        <label className={styles.slash_shaded}>/</label>
                        <div className={styles.hand12_column_shaded}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='RORINGPIPFLEXIONAROMR'
                                className={styles.arom_hand}
                                placeholder={this.props.prevRingPipFlexionAromR}
                            />
                        </div>
                        <div className={styles.hand12_column_shaded}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='RORINGPIPEXTENSIONAROML'
                                className={styles.arom_hand}
                                placeholder={this.props.prevRingPipExtensionAromL}
                            />
                        </div>
                        <label className={styles.slash_shaded}>/</label>
                        <div className={styles.hand12_column_shaded}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='RORINGPIPFLEXIONAROML'
                                className={styles.arom_hand}
                                placeholder={this.props.prevRingPipFlexionAromL}
                            />
                        </div>

                        <div className={styles.hand12_column}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='RORINGDIPEXTENSIONAROMR'
                                className={styles.arom_hand}
                                placeholder={this.props.prevRingDipExtensionAromR}
                            />
                        </div>
                        <label className={styles.slash}>/</label>
                        <div className={styles.hand12_column}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='RORINGDIPFLEXIONAROMR'
                                className={styles.arom_hand}
                                placeholder={this.props.prevRingDipFlexionAromR}
                            />
                        </div>
                        <div className={styles.hand12_column}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='RORINGDIPEXTENSIONAROML'
                                className={styles.arom_hand}
                                placeholder={this.props.prevRingDipExtensionAromL}
                            />
                        </div>
                        <label className={styles.slash}>/</label>
                        <div className={styles.hand12_column}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='RORINGDIPFLEXIONAROML'
                                className={styles.arom_hand}
                                placeholder={this.props.prevRingDipFlexionAromL}
                            />
                        </div>
                    </div>
                    <div className={styles.row_hand}>
                        <ObjectiveFlag className={styles.flag} flagged={this.props.smallAROM} mopno={this.props.mopno} flagText='Small Finger - AROM' />
                        <div className={styles.rowTitle}>
                            Small Finger
                        </div>
                        <div className={styles.hand12_column}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='ROSMALLMCPEXTENSIONAROMR'
                                className={styles.arom_hand}
                                placeholder={this.props.prevSmallMcExtensionAromR}
                            />
                        </div>
                        <label className={styles.slash}>/</label>
                        <div className={styles.hand12_column}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='ROSMALLMCPFLEXIONAROMR'
                                className={styles.arom_hand}
                                placeholder={this.props.prevSmallMcpFlexionAromR}
                            />
                        </div>
                        <div className={styles.hand12_column}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='ROSMALLMCPEXTENSIONAROML'
                                className={styles.arom_hand}
                                placeholder={this.props.prevSmallMcExtensionAromL}
                            />
                        </div>
                        <label className={styles.slash}>/</label>
                        <div className={styles.hand12_column}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='ROSMALLMCPFLEXIONAROML'
                                className={styles.arom_hand}
                                placeholder={this.props.prevSmallMcpFlexionAromL}
                            />
                        </div>

                        <div className={styles.hand12_column_shaded}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='ROSMALLPIPEXTENSIONAROMR'
                                className={styles.arom_hand}
                                placeholder={this.props.prevSmallPipExtensionAromR}
                            />
                        </div>
                        <label className={styles.slash_shaded}>/</label>
                        <div className={styles.hand12_column_shaded}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='ROSMALLPIPFLEXIONAROMR'
                                className={styles.arom_hand}
                                placeholder={this.props.prevSmallPipFlexionAromR}
                            />
                        </div>
                        <div className={styles.hand12_column_shaded}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='ROSMALLPIPEXTENSIONAROML'
                                className={styles.arom_hand}
                                placeholder={this.props.prevSmallPipExtensionAromL}
                            />
                        </div>
                        <label className={styles.slash_shaded}>/</label>
                        <div className={styles.hand12_column_shaded}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='ROSMALLPIPFLEXIONAROML'
                                className={styles.arom_hand}
                                placeholder={this.props.prevSmallPipFlexionAromL}
                            />
                        </div>

                        <div className={styles.hand12_column}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='ROSMALLDIPEXTENSIONAROMR'
                                className={styles.arom_hand}
                                placeholder={this.props.prevSmallDipExtensionAromR}
                            />
                        </div>
                        <label className={styles.slash}>/</label>
                        <div className={styles.hand12_column}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='ROSMALLDIPFLEXIONAROMR'
                                className={styles.arom_hand}
                                placeholder={this.props.prevSmallDipFlexionAromR}
                            />
                        </div>
                        <div className={styles.hand12_column}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='ROSMALLDIPEXTENSIONAROML'
                                className={styles.arom_hand}
                                placeholder={this.props.prevSmallDipExtensionAromL}
                            />
                        </div>
                        <label className={styles.slash}>/</label>
                        <div className={styles.hand12_column}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='ROSMALLDIPFLEXIONAROML'
                                className={styles.arom_hand}
                                placeholder={this.props.prevSmallDipFlexionAromL}
                            />
                        </div>
                    </div>
                    <div className={styles.rowSpacer}></div>
                    <div className={styles.row_hand}>
                        <div className={styles.center}>
                            AROM - Thumb
                        </div>
                    </div>
                    <div className={styles.row_hand}>
                        <div className={styles.flag}></div>
                        <div className={styles.rowTitle_large}></div>
                        <div className={styles.hand12_column}>
                            R
                        </div>

                        <div className={styles.hand12_column}>
                            L
                        </div>
                    </div>
                    <div className={styles.row_hand}>
                        <div className={styles.flag}></div>
                        <div className={styles.rowTitle_large}></div>
                        <div className={styles.hand12_column}>
                        <AddButton size='extra-small' title={'WFL'} onClick={() => this.updateValue('AROMTHUMBR')} />
                        </div>

                        <div className={styles.hand12_column}>
                        <AddButton size='extra-small' title={'WFL'} onClick={() => this.updateValue('AROMTHUMBL')} />
                        </div>
                    </div>
                    <div className={styles.row_hand}>
                        <ObjectiveFlag className={styles.flag} flagged={this.props.thumbMCPExAROM} mopno={this.props.mopno} flagText='Thumb MCP Extension - AROM' />
                        <div className={styles.rowTitle_large}>
                            Thumb MCP Extension
                        </div>
                        <div className={styles.hand12_column}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='ROTHUMBMCPEXTENSIONAROMR'
                                className={styles.arom_hand}
                                placeholder={this.props.prevThumbMcExtensionAromR}
                            />
                        </div>
                        <div className={styles.hand12_column}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='ROTHUMBMCPEXTENSIONAROML'
                                className={styles.arom_hand}
                                placeholder={this.props.prevThumbMcExtensionAromL}
                            />
                        </div>
                    </div>
                    <div className={styles.row_hand}>
                        <ObjectiveFlag className={styles.flag} flagged={this.props.thumbMCPFxAROM} mopno={this.props.mopno} flagText='Thumb MCP Flexion - AROM' />
                        <div className={styles.rowTitle_large}>
                            Thumb MCP Flexion
                        </div>
                        <div className={styles.hand12_column}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='ROTHUMBMCPFLEXIONAROMR'
                                className={styles.arom_hand}
                                placeholder={this.props.prevThumbMcpFlexionAromR}
                            />
                        </div>
                        <div className={styles.hand12_column}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='ROTHUMBMCPFLEXIONAROML'
                                className={styles.arom_hand}
                                placeholder={this.props.prevThumbMcpFlexionAromL}
                            />
                        </div>
                    </div>
                    <div className={styles.row_hand}>
                        <ObjectiveFlag className={styles.flag} flagged={this.props.thumbIPExAROM} mopno={this.props.mopno} flagText='Thumb IP Extension - AROM' />
                        <div className={styles.rowTitle_large}>
                            Thumb IP Extension
                        </div>
                        <div className={styles.hand12_column}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='ROTHUMBIPEXTENSIONAROMR'
                                className={styles.arom_hand}
                                placeholder={this.props.prevThumbIpExtensionAromR}
                            />
                        </div>
                        <div className={styles.hand12_column}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='ROTHUMBIPEXTENSIONAROML'
                                className={styles.arom_hand}
                                placeholder={this.props.prevThumbIpExtensionAromL}
                            />
                        </div>
                    </div>
                    <div className={styles.row_hand}>
                        <ObjectiveFlag className={styles.flag} flagged={this.props.thumbIPFxAROM} mopno={this.props.mopno} flagText='Thumb IP Flexion - AROM' />
                        <div className={styles.rowTitle_large}>
                            Thumb IP Flexion
                        </div>
                        <div className={styles.hand12_column}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='ROTHUMBIPFLEXIONAROMR'
                                className={styles.arom_hand}
                                placeholder={this.props.prevThumbIpFlexionAromR}
                            />
                        </div>
                        <div className={styles.hand12_column}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='ROTHUMBIPFLEXIONAROML'
                                className={styles.arom_hand}
                                placeholder={this.props.prevThumbIpFlexionAromL}
                            />
                        </div>
                    </div>
                    <div className={styles.row_hand}>
                        <ObjectiveFlag className={styles.flag} flagged={this.props.thumbAbdAROM} mopno={this.props.mopno} flagText='Thumb Abduction - AROM' />
                        <div className={styles.rowTitle_large}>
                            Thumb Abduction
                        </div>
                        <div className={styles.hand12_column}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='ROTHUMBABDUCTIONAROMR'
                                className={styles.arom_hand}
                                placeholder={this.props.prevThumbAdductionAromR}
                            />
                        </div>
                        <div className={styles.hand12_column}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='ROTHUMBABDUCTIONAROML'
                                className={styles.arom_hand}
                                placeholder={this.props.prevThumbAdductionAromL}
                            />
                        </div>
                    </div>
                    <div className={styles.row_hand}>
                        <ObjectiveFlag className={styles.flag} flagged={this.props.thumbAddAROM} mopno={this.props.mopno} flagText='Thumb Adduction - AROM' />
                        <div className={styles.rowTitle_large}>
                            Thumb Adduction
                        </div>
                        <div className={styles.hand12_column}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='ROTHUMBADDUCTIONAROMR'
                                className={styles.arom_hand}
                                placeholder={this.props.prevThumbAbductionAromR}
                            />
                        </div>
                        <div className={styles.hand12_column}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='ROTHUMBADDUCTIONAROML'
                                className={styles.arom_hand}
                                placeholder={this.props.prevThumbAbductionAromL}
                            />
                        </div>
                    </div>
                    <div className={styles.row_hand}>
                        <ObjectiveFlag className={styles.flag} flagged={this.props.DigitOppAROM} mopno={this.props.mopno} flagText='Digit Opposition - AROM' />
                        <div className={styles.rowTitle_large}>
                            Digit Opposition
                        </div>
                        <div className={styles.hand12_column}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='RODIGITOPPOSITIONAROMR'
                                className={styles.arom_hand}
                                placeholder={this.props.prevDigitOppositionAromR}
                            />
                        </div>
                        <div className={styles.hand12_column}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='RODIGITOPPOSITIONAROML'
                                className={styles.arom_hand}
                                placeholder={this.props.prevDigitOppositionAromL}
                            />
                        </div>
                    </div>



                    <div className={styles.rowSpacer}></div>
                    <div className={styles.row_hand}>
                        <div className={styles.center}>
                            PROM
                        </div>
                    </div>
                    <div className={styles.row_hand}>
                        <div className={styles.flag}></div>
                        <div className={styles.rowTitle}></div>
                        <div className={styles.hand3_column}>
                            MC
                        </div>
                        <div className={styles.hand3_column_shaded}>
                            PIP
                        </div>
                        <div className={styles.hand3_column}>
                            DIP
                        </div>
                    </div>
                    <div className={styles.row_hand}>
                        <div className={styles.flag}></div>
                        <div className={styles.rowTitle}></div>
                        <div className={styles.hand6_column}>
                            R
                        </div>
                        <div className={styles.hand6_column}>
                            L
                        </div>
                        <div className={styles.hand6_column_shaded}>
                            R
                        </div>
                        <div className={styles.hand6_column_shaded}>
                            L
                        </div>
                        <div className={styles.hand6_column}>
                            R
                        </div>
                        <div className={styles.hand6_column}>
                            L
                        </div>
                    </div>
            
                    <div className={styles.row_hand}>
                        <div className={styles.flag}></div>
                        <div className={styles.rowTitle}></div>
                        <div className={styles.hand12_column}>
                            Ext
                        </div>
                        <label className={styles.slash}>/</label>
                        <div className={styles.hand12_column}>
                            Flex
                        </div>
                        <div className={styles.hand12_column}>
                            Ext
                        </div>
                        <label className={styles.slash}>/</label>
                        <div className={styles.hand12_column}>
                            Flex
                        </div>
                        <div className={styles.hand12_column_shaded}>
                            Ext
                        </div>
                        <label className={styles.slash_shaded}>/</label>
                        <div className={styles.hand12_column_shaded}>
                            Flex
                        </div>
                        <div className={styles.hand12_column_shaded}>
                            Ext
                        </div>
                        <label className={styles.slash_shaded}>/</label>
                        <div className={styles.hand12_column_shaded}>
                            Flex
                        </div>
                        <div className={styles.hand12_column}>
                            Ext
                        </div>
                        <label className={styles.slash}>/</label>
                        <div className={styles.hand12_column}>
                            Flex
                        </div>
                        <div className={styles.hand12_column}>
                            Ext
                        </div>
                        <label className={styles.slash}>/</label>
                        <div className={styles.hand12_column}>
                            Flex
                        </div>
                    </div>
                    <div className={styles.row_hand}>
                        <div className={styles.flag}></div>
                        <div className={styles.rowTitle}></div>
                        <div className={styles.hand12_column}>
                        <AddButton size='extra-small' title={'WFL'} onClick={() => this.updateValue('PROMMCREXT')} />
                        </div>
                        <label className={styles.slash}>/</label>
                        <div className={styles.hand12_column}>
                        <AddButton size='extra-small' title={'WFL'} onClick={() => this.updateValue('PROMMCRFLEX')} />
                        </div>
                        <div className={styles.hand12_column}>
                        <AddButton size='extra-small' title={'WFL'} onClick={() => this.updateValue('PROMMCLEXT')} />
                        </div>
                        <label className={styles.slash}>/</label>
                        <div className={styles.hand12_column}>
                        <AddButton size='extra-small' title={'WFL'} onClick={() => this.updateValue('PROMMCLFLEX')} />
                        </div>
                        <div className={styles.hand12_column_shaded}>
                        <AddButton size='extra-small' title={'WFL'} onClick={() => this.updateValue('PROMPIPREXT')} />
                        </div>
                        <label className={styles.slash_shaded}>/</label>
                        <div className={styles.hand12_column_shaded}>
                        <AddButton size='extra-small' title={'WFL'} onClick={() => this.updateValue('PROMPIPRFLEX')} />
                        </div>
                        <div className={styles.hand12_column_shaded}>
                        <AddButton size='extra-small' title={'WFL'} onClick={() => this.updateValue('PROMPIPLEXT')} />
                        </div>
                        <label className={styles.slash_shaded}>/</label>
                        <div className={styles.hand12_column_shaded}>
                        <AddButton size='extra-small' title={'WFL'} onClick={() => this.updateValue('PROMPIPLFLEX')} />
                        </div>
                        <div className={styles.hand12_column}>
                        <AddButton size='extra-small' title={'WFL'} onClick={() => this.updateValue('PROMDIPREXT')} />
                        </div>
                        <label className={styles.slash}>/</label>
                        <div className={styles.hand12_column}>
                        <AddButton size='extra-small' title={'WFL'} onClick={() => this.updateValue('PROMDIPRFLEX')} />
                        </div>
                        <div className={styles.hand12_column}>
                        <AddButton size='extra-small' title={'WFL'} onClick={() => this.updateValue('PROMDIPLEXT')} />
                        </div>
                        <label className={styles.slash}>/</label>
                        <div className={styles.hand12_column}>
                        <AddButton size='extra-small' title={'WFL'} onClick={() => this.updateValue('PROMDIPLFLEX')} />
                        </div>
                    </div>
                    <div className={styles.row_hand}>
                        <ObjectiveFlag className={styles.flag} flagged={this.props.indexPROM} mopno={this.props.mopno} flagText='Index Finger - PROM' />
                        <div className={styles.rowTitle}>
                            Index Finger
                        </div>
                        <div className={styles.hand12_column}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='ROINDEXMCPEXTENSIONPROMR'
                                className={styles.arom_hand}
                                placeholder={this.props.prevIndexMcExtensionPromR}
                            />
                        </div>
                        <label className={styles.slash}>/</label>
                        <div className={styles.hand12_column}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='ROINDEXMCPFLEXIONPROMR'
                                className={styles.arom_hand}
                                placeholder={this.props.prevIndexMcpFlexionPromR}
                            />
                        </div>
                        <div className={styles.hand12_column}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='ROINDEXMCPEXTENSIONPROML'
                                className={styles.arom_hand}
                                placeholder={this.props.prevIndexMcExtensionPromL}
                            />
                        </div>
                        <label className={styles.slash}>/</label>
                        <div className={styles.hand12_column}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='ROINDEXMCPFLEXIONPROML'
                                className={styles.arom_hand}
                                placeholder={this.props.prevIndexMcpFlexionPromL}
                            />
                        </div>

                        <div className={styles.hand12_column_shaded}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='ROINDEXPIPEXTENSIONPROMR'
                                className={styles.arom_hand}
                                placeholder={this.props.prevIndexPipExtensionPromR}
                            />
                        </div>
                        <label className={styles.slash_shaded}>/</label>
                        <div className={styles.hand12_column_shaded}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='ROINDEXPIPFLEXIONPROMR'
                                className={styles.arom_hand}
                                placeholder={this.props.prevIndexPipFlexionPromR}
                            />
                        </div>
                        <div className={styles.hand12_column_shaded}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='ROINDEXPIPEXTENSIONPROML'
                                placeholder={this.props.prevIndexPipExtensionPromL}
                                className={styles.arom_hand}
                            />
                        </div>
                        <label className={styles.slash_shaded}>/</label>
                        <div className={styles.hand12_column_shaded}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='ROINDEXPIPFLEXIONPROML'
                                className={styles.arom_hand}
                                placeholder={this.props.prevIndexPipFlexionPromL}
                            />
                        </div>

                        <div className={styles.hand12_column}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='ROINDEXDIPEXTENSIONPROMR'
                                placeholder={this.props.prevIndexDipExtensionPromR}
                                className={styles.arom_hand}
                            />
                        </div>
                        <label className={styles.slash}>/</label>
                        <div className={styles.hand12_column}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='ROINDEXDIPFLEXIONPROMR'
                                placeholder={this.props.prevIndexDipFlexionPromR}
                                className={styles.arom_hand}
                            />
                        </div>
                        <div className={styles.hand12_column}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='ROINDEXDIPEXTENSIONPROML'
                                placeholder={this.props.prevIndexDipExtensionPromL}
                                className={styles.arom_hand}
                            />
                        </div>
                        <label className={styles.slash}>/</label>
                        <div className={styles.hand12_column}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='ROINDEXDIPFLEXIONPROML'
                                placeholder={this.props.prevIndexDipFlexionPromL}
                                className={styles.arom_hand}
                            />
                        </div>
                    </div>
                    <div className={styles.row_hand}>
                        <ObjectiveFlag className={styles.flag} flagged={this.props.middlePROM} mopno={this.props.mopno} flagText='Middle Finger - PROM' />
                        <div className={styles.rowTitle}>
                            Middle Finger
                        </div>
                        <div className={styles.hand12_column}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='ROMIDDLEMCPEXTENSIONPROMR'
                                className={styles.arom_hand}
                                placeholder={this.props.prevMiddleMcExtensionPromR}
                            />
                        </div>
                        <label className={styles.slash}>/</label>
                        <div className={styles.hand12_column}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='ROMIDDLEMCPFLEXIONPROMR'
                                className={styles.arom_hand}
                                placeholder={this.props.prevMiddleMcpFlexionPromR}
                            />
                        </div>
                        <div className={styles.hand12_column}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='ROMIDDLEMCPEXTENSIONPROML'
                                className={styles.arom_hand}
                                placeholder={this.props.prevMiddleMcExtensionPromL}
                            />
                        </div>
                        <label className={styles.slash}>/</label>
                        <div className={styles.hand12_column}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='ROMIDDLEMCPFLEXIONPROML'
                                className={styles.arom_hand}
                                placeholder={this.props.prevMiddleMcpFlexionPromL}
                            />
                        </div>

                        <div className={styles.hand12_column_shaded}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='ROMIDDLEPIPEXTENSIONPROMR'
                                placeholder={this.props.prevMiddlePipExtensionPromR}
                                className={styles.arom_hand}
                            />
                        </div>
                        <label className={styles.slash_shaded}>/</label>
                        <div className={styles.hand12_column_shaded}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='ROMIDDLEPIPFLEXIONPROMR'
                                className={styles.arom_hand}
                                placeholder={this.props.prevMiddlePipFlexionPromR}
                            />
                        </div>
                        <div className={styles.hand12_column_shaded}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='ROMIDDLEPIPEXTENSIONPROML'
                                className={styles.arom_hand}
                                placeholder={this.props.prevMiddlePipExtensionPromL}
                            />
                        </div>
                        <label className={styles.slash_shaded}>/</label>
                        <div className={styles.hand12_column_shaded}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='ROMIDDLEPIPFLEXIONPROML'
                                className={styles.arom_hand}
                                placeholder={this.props.prevMiddlePipFlexionPromL}
                            />
                        </div>

                        <div className={styles.hand12_column}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='ROMIDDLEDIPEXTENSIONPROMR'
                                className={styles.arom_hand}
                                placeholder={this.props.prevMiddleDipExtensionPromR}
                            />
                        </div>
                        <label className={styles.slash}>/</label>
                        <div className={styles.hand12_column}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='ROMIDDLEDIPFLEXIONPROMR'
                                className={styles.arom_hand}
                                placeholder={this.props.prevMiddleDipFlexionPromR}
                            />
                        </div>
                        <div className={styles.hand12_column}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='ROMIDDLEDIPEXTENSIONPROML'
                                className={styles.arom_hand}
                                placeholder={this.props.prevMiddleDipExtensionPromL}
                            />
                        </div>
                        <label className={styles.slash}>/</label>
                        <div className={styles.hand12_column}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='ROMIDDLEDIPFLEXIONPROML'
                                className={styles.arom_hand}
                                placeholder={this.props.prevMiddleDipFlexionPromL}
                            />
                        </div>
                    </div>
                    <div className={styles.row_hand}>
                        <ObjectiveFlag className={styles.flag} flagged={this.props.ringPROM} mopno={this.props.mopno} flagText='Ring Finger - PROM' />
                        <div className={styles.rowTitle}>
                            Ring Finger
                        </div>
                        <div className={styles.hand12_column}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='RORINGMCPEXTENSIONPROMR'
                                className={styles.arom_hand}
                                placeholder={this.props.prevRingMcExtensionPromR}
                            />
                        </div>
                        <label className={styles.slash}>/</label>
                        <div className={styles.hand12_column}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='RORINGMCPFLEXIONPROMR'
                                className={styles.arom_hand}
                                placeholder={this.props.prevRingMcpFlexionPromR}
                            />
                        </div>
                        <div className={styles.hand12_column}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='RORINGMCPEXTENSIONPROML'
                                className={styles.arom_hand}
                                placeholder={this.props.prevRingMcExtensionPromL}
                            />
                        </div>
                        <label className={styles.slash}>/</label>
                        <div className={styles.hand12_column}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='RORINGMCPFLEXIONPROML'
                                className={styles.arom_hand}
                                placeholder={this.props.prevRingMcpFlexionPromL}
                            />
                        </div>

                        <div className={styles.hand12_column_shaded}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='RORINGPIPEXTENSIONPROMR'
                                placeholder={this.props.prevRingPipExtensionPromR}
                                className={styles.arom_hand}
                            />
                        </div>
                        <label className={styles.slash_shaded}>/</label>
                        <div className={styles.hand12_column_shaded}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='RORINGPIPFLEXIONPROMR'
                                placeholder={this.props.prevRingPipFlexionPromR}
                                className={styles.arom_hand}
                            />
                        </div>
                        <div className={styles.hand12_column_shaded}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                placeholder={this.props.prevRingPipExtensionPromL}
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='RORINGPIPEXTENSIONPROML'
                                className={styles.arom_hand}
                            />
                        </div>
                        <label className={styles.slash_shaded}>/</label>
                        <div className={styles.hand12_column_shaded}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='RORINGPIPFLEXIONPROML'
                                className={styles.arom_hand}
                                placeholder={this.props.prevRingPipFlexionPromL}
                            />
                        </div>

                        <div className={styles.hand12_column}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='RORINGDIPEXTENSIONPROMR'
                                placeholder={this.props.prevRingDipExtensionPromR}
                                className={styles.arom_hand}
                            />
                        </div>
                        <label className={styles.slash}>/</label>
                        <div className={styles.hand12_column}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='RORINGDIPFLEXIONPROMR'
                                placeholder={this.props.prevRingDipFlexionPromR}
                                className={styles.arom_hand}
                            />
                        </div>
                        <div className={styles.hand12_column}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                placeholder={this.props.prevRingDipExtensionPromL}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='RORINGDIPEXTENSIONPROML'
                                className={styles.arom_hand}
                            />
                        </div>
                        <label className={styles.slash}>/</label>
                        <div className={styles.hand12_column}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='RORINGDIPFLEXIONPROML'
                                className={styles.arom_hand}
                                placeholder={this.props.prevRingDipFlexionPromL}
                            />
                        </div>
                    </div>
                    <div className={styles.row_hand}>
                        <ObjectiveFlag className={styles.flag} flagged={this.props.smallPROM} mopno={this.props.mopno} flagText='Small Finger - PROM' />
                        <div className={styles.rowTitle}>
                            Small Finger
                        </div>
                        <div className={styles.hand12_column}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='ROSMALLMCPEXTENSIONPROMR'
                                placeholder={this.props.prevSmallMcExtensionPromR}
                                className={styles.arom_hand}
                            />
                        </div>
                        <label className={styles.slash}>/</label>
                        <div className={styles.hand12_column}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                placeholder={this.props.prevSmallMcpFlexionPromR}
                                field='ROSMALLMCPFLEXIONPROMR'
                                className={styles.arom_hand}
                            />
                        </div>
                        <div className={styles.hand12_column}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='ROSMALLMCPEXTENSIONPROML'
                                placeholder={this.props.prevSmallMcExtensionPromL}
                                className={styles.arom_hand}
                            />
                        </div>
                        <label className={styles.slash}>/</label>
                        <div className={styles.hand12_column}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                placeholder={this.props.prevSmallMcpFlexionPromL}
                                entityKeyValue={this.props.rono}
                                field='ROSMALLMCPFLEXIONPROML'
                                className={styles.arom_hand}
                            />
                        </div>

                        <div className={styles.hand12_column_shaded}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='ROSMALLPIPEXTENSIONPROMR'
                                className={styles.arom_hand}
                                placeholder={this.props.prevSmallPipExtensionPromR}
                            />
                        </div>
                        <label className={styles.slash_shaded}>/</label>
                        <div className={styles.hand12_column_shaded}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='ROSMALLPIPFLEXIONPROMR'
                                className={styles.arom_hand}
                                placeholder={this.props.prevSmallPipFlexionPromR}
                            />
                        </div>
                        <div className={styles.hand12_column_shaded}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='ROSMALLPIPEXTENSIONPROML'
                                className={styles.arom_hand}
                                placeholder={this.props.prevSmallPipExtensionPromL}
                            />
                        </div>
                        <label className={styles.slash_shaded}>/</label>
                        <div className={styles.hand12_column_shaded}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='ROSMALLPIPFLEXIONPROML'
                                className={styles.arom_hand}
                                placeholder={this.props.prevSmallPipFlexionPromL}
                            />
                        </div>

                        <div className={styles.hand12_column}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='ROSMALLDIPEXTENSIONPROMR'
                                className={styles.arom_hand}
                                placeholder={this.props.prevSmallDipExtensionPromR}
                            />
                        </div>
                        <label className={styles.slash}>/</label>
                        <div className={styles.hand12_column}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='ROSMALLDIPFLEXIONPROMR'
                                className={styles.arom_hand}
                                placeholder={this.props.prevSmallDipFlexionPromR}
                            />
                        </div>
                        <div className={styles.hand12_column}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='ROSMALLDIPEXTENSIONPROML'
                                className={styles.arom_hand}
                                placeholder={this.props.prevSmallDipExtensionPromL}
                            />
                        </div>
                        <label className={styles.slash}>/</label>
                        <div className={styles.hand12_column}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='ROSMALLDIPFLEXIONPROML'
                                className={styles.arom_hand}
                                placeholder={this.props.prevSmallDipFlexionPromL}
                            />
                        </div>
                    </div>
                    <div className={styles.rowSpacer}></div>
                    <div className={styles.row_hand}>
                        <div className={styles.center}>
                            PROM - Thumb
                        </div>
                    </div>
                    <div className={styles.row_hand}>
                        <div className={styles.flag}></div>
                        <div className={styles.rowTitle_large}></div>
                        <div className={styles.hand12_column}>
                            R
                        </div>

                        <div className={styles.hand12_column}>
                            L
                        </div>
                    </div>
                    <div className={styles.row_hand}>
                        <div className={styles.flag}></div>
                        <div className={styles.rowTitle_large}></div>
                        <div className={styles.hand12_column}>
                        <AddButton size='extra-small' title={'WFL'} onClick={() => this.updateValue('PROMTHUMBR')} />
                        </div>

                        <div className={styles.hand12_column}>
                        <AddButton size='extra-small' title={'WFL'} onClick={() => this.updateValue('PROMTHUMBL')} />
                        </div>
                    </div>
                    <div className={styles.row_hand}>
                        <ObjectiveFlag className={styles.flag} flagged={this.props.thumbMCPExPROM} mopno={this.props.mopno} flagText='Thumb MCP Extension - PROM' />
                        <div className={styles.rowTitle_large}>
                            Thumb MCP Extension
                        </div>
                        <div className={styles.hand12_column}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='ROTHUMBMCPEXTENSIONPROMR'
                                className={styles.arom_hand}
                                placeholder={this.props.prevThumbMcpExtensionPromR}
                            />
                        </div>
                        <div className={styles.hand12_column}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='ROTHUMBMCPEXTENSIONPROML'
                                className={styles.arom_hand}
                                placeholder={this.props.prevThumbMcpExtensionPromL}
                            />
                        </div>
                    </div>
                    <div className={styles.row_hand}>
                        <ObjectiveFlag className={styles.flag} flagged={this.props.thumbMCPFxPROM} mopno={this.props.mopno} flagText='Thumb MCP Flexion - PROM' />
                        <div className={styles.rowTitle_large}>
                            Thumb MCP Flexion
                        </div>
                        <div className={styles.hand12_column}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='ROTHUMBMCPFLEXIONPROMR'
                                className={styles.arom_hand}
                                placeholder={this.props.prevThumbMcpFlexionPromR}
                            />
                        </div>
                        <div className={styles.hand12_column}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='ROTHUMBMCPFLEXIONPROML'
                                className={styles.arom_hand}
                                placeholder={this.props.prevThumbMcpFlexionPromL}
                            />
                        </div>
                    </div>
                    <div className={styles.row_hand}>
                        <ObjectiveFlag className={styles.flag} flagged={this.props.thumbIPExPROM} mopno={this.props.mopno} flagText='Thumb IP Extesnion - PROM' />
                        <div className={styles.rowTitle_large}>
                            Thumb IP Extension
                        </div>
                        <div className={styles.hand12_column}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='ROTHUMBIPEXTENSIONPROMR'
                                className={styles.arom_hand}
                                placeholder={this.props.prevThumbIpExtensionPromR}
                            />
                        </div>
                        <div className={styles.hand12_column}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='ROTHUMBIPEXTENSIONPROML'
                                className={styles.arom_hand}
                                placeholder={this.props.prevThumbIpExtensionPromL}
                            />
                        </div>
                    </div>
                    <div className={styles.row_hand}>
                        <ObjectiveFlag className={styles.flag} flagged={this.props.thumbIPFxPROM} mopno={this.props.mopno} flagText='Thumb IP Flexion - PROM' />
                        <div className={styles.rowTitle_large}>
                            Thumb IP Flexion
                        </div>
                        <div className={styles.hand12_column}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                placeholder={this.props.prevThumbIpFlexionPromR}
                                entityKeyValue={this.props.rono}
                                field='ROTHUMBIPFLEXIONPROMR'
                                className={styles.arom_hand}
                            />
                        </div>
                        <div className={styles.hand12_column}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='ROTHUMBIPFLEXIONPROML'
                                className={styles.arom_hand}
                                placeholder={this.props.prevThumbIpFlexionPromL}
                            />
                        </div>
                    </div>
                    <div className={styles.row_hand}>
                        <ObjectiveFlag className={styles.flag} flagged={this.props.thumbAbdPROM} mopno={this.props.mopno} flagText='Thumb Abduction - PROM' />
                        <div className={styles.rowTitle_large}>
                            Thumb Abduction
                        </div>
                        <div className={styles.hand12_column}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='ROTHUMBABDUCTIONPROMR'
                                placeholder={this.props.prevThumbAbductionPromR}
                                className={styles.arom_hand}
                            />
                        </div>
                        <div className={styles.hand12_column}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                field='ROTHUMBABDUCTIONPROML'
                                placeholder={this.props.prevThumbAbductionPromL}
                                className={styles.arom_hand}
                            />
                        </div>
                    </div>
                    <div className={styles.row_hand}>
                        <ObjectiveFlag className={styles.flag} flagged={this.props.thumbAddPROM} mopno={this.props.mopno} flagText='Thumb Adduction - PROM' />
                        <div className={styles.rowTitle_large}>
                            Thumb Adduction
                        </div>
                        <div className={styles.hand12_column}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                placeholder={this.props.prevThumbAdductionPromR}
                                field='ROTHUMBADDUCTIONPROMR'
                                className={styles.arom_hand}
                            />
                        </div>
                        <div className={styles.hand12_column}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                placeholder={this.props.prevThumbAdductionPromL}
                                field='ROTHUMBADDUCTIONPROML'
                                className={styles.arom_hand}
                            />
                        </div>
                    </div>
                    <div className={styles.row_hand}>
                        <ObjectiveFlag className={styles.flag} flagged={this.props.DigitOppPROM} mopno={this.props.mopno} flagText='Digit Opposition - PROM' />
                        <div className={styles.rowTitle_large}>
                            Digit Opposition
                        </div>
                        <div className={styles.hand12_column}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                entityKeyValue={this.props.rono}
                                placeholder={this.props.prevDigitOppositionPromR}
                                field='RODIGITOPPOSITIONPROMR'
                                className={styles.arom_hand}
                            />
                        </div>
                        <div className={styles.hand12_column}>
                            <DBTextFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                placeholder={this.props.prevDigitOppositionPromL}
                                entityKeyValue={this.props.rono}
                                field='RODIGITOPPOSITIONPROML'
                                className={styles.arom_hand}
                            />
                        </div>
                    </div>
                    <div className={styles.rowSpacer}></div>
                    <div className={styles.row_hand}>
                        <div className={styles.comment_center}>
                            Comment
                        </div>
                    </div>
                    <DBTextArea
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVEROM'
                        entityKeyColumn='RONO'
                        entityKeyValue={this.props.rono}
                        field='ROHANDCOMMENTS'
                        className={styles.comment_textarea}
                        placeholder='Add Comment'
                />
                </PatientCareCenterNoteSection>
            </>
        );
    }
}

function mapStateToProps(state, ownprops) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let rono = parseInt(Object.keys(state.entities.notes.PTOBJECTIVEROM)
        .find(key => (state.entities.notes.PTOBJECTIVEROM[key].ROEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVEROM[key].RONTNO === pk && noteType !== 1)));
    let flagged = false;


    let indexAROM = false;
    let middleAROM = false;
    let ringAROM = false;
    let smallAROM = false;
    let thumbMCPExAROM = false;
    let thumbMCPFxAROM = false;
    let thumbIPExAROM = false;
    let thumbIPFxAROM = false;
    let thumbAddAROM = false;
    let thumbAbdAROM = false;
    let DigitOppAROM = false;

    if (state.entities.notes.PTOBJECTIVEROM[rono].ROINDEXMCPEXTENSIONAROMR !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].ROINDEXMCPFLEXIONAROMR !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].ROINDEXMCPEXTENSIONAROML !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].ROINDEXMCPFLEXIONAROML !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].ROINDEXPIPEXTENSIONAROMR !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].ROINDEXPIPFLEXIONAROMR !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].ROINDEXPIPEXTENSIONAROML !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].ROINDEXPIPFLEXIONAROML !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].ROINDEXDIPEXTENSIONAROMR !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].ROINDEXDIPFLEXIONAROMR !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].ROINDEXDIPEXTENSIONAROML !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].ROINDEXDIPFLEXIONAROML !== null) {
        indexAROM = true;
    }

    if (state.entities.notes.PTOBJECTIVEROM[rono].ROMIDDLEMCPEXTENSIONAROMR !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].ROMIDDLEMCPFLEXIONAROMR !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].ROMIDDLEMCPEXTENSIONAROML !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].ROMIDDLEMCPFLEXIONAROML !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].ROMIDDLEPIPEXTENSIONAROMR !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].ROMIDDLEPIPFLEXIONAROMR !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].ROMIDDLEPIPEXTENSIONAROML !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].ROMIDDLEPIPFLEXIONAROML !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].ROMIDDLEDIPEXTENSIONAROMR !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].ROMIDDLEDIPFLEXIONAROMR !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].ROMIDDLEDIPEXTENSIONAROML !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].ROMIDDLEDIPFLEXIONAROML !== null) {
        middleAROM = true;
    }

    if (state.entities.notes.PTOBJECTIVEROM[rono].RORINGMCPEXTENSIONAROMR !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].RORINGMCPFLEXIONAROMR !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].RORINGMCPEXTENSIONAROML !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].RORINGMCPFLEXIONAROML !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].RORINGPIPEXTENSIONAROMR !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].RORINGPIPFLEXIONAROMR !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].RORINGPIPEXTENSIONAROML !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].RORINGPIPFLEXIONAROML !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].RORINGDIPEXTENSIONAROMR !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].RORINGDIPFLEXIONAROMR !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].RORINGDIPEXTENSIONAROML !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].RORINGDIPFLEXIONAROML !== null) {
        ringAROM = true;
    }

    if (state.entities.notes.PTOBJECTIVEROM[rono].ROSMALLMCPEXTENSIONAROMR !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].ROSMALLMCPFLEXIONAROMR !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].ROSMALLMCPEXTENSIONAROML !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].ROSMALLMCPFLEXIONAROML !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].ROSMALLPIPEXTENSIONAROMR !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].ROSMALLPIPFLEXIONAROMR !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].ROSMALLPIPEXTENSIONAROML !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].ROSMALLPIPFLEXIONAROML !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].ROSMALLDIPEXTENSIONAROMR !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].ROSMALLDIPFLEXIONAROMR !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].ROSMALLDIPEXTENSIONAROML !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].ROSMALLDIPFLEXIONAROML !== null) {
        smallAROM = true;
    }

    if (state.entities.notes.PTOBJECTIVEROM[rono].ROTHUMBMCPEXTENSIONAROMR !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].ROTHUMBMCPEXTENSIONAROML !== null) {
        thumbMCPExAROM = true;
    }
    if (state.entities.notes.PTOBJECTIVEROM[rono].ROTHUMBMCPFLEXIONAROMR !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].ROTHUMBMCPFLEXIONAROML !== null) {
        thumbMCPFxAROM = true;
    }

    if (state.entities.notes.PTOBJECTIVEROM[rono].ROTHUMBIPEXTENSIONAROMR !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].ROTHUMBIPEXTENSIONAROML !== null) {
        thumbIPExAROM = true;
    }
    if (state.entities.notes.PTOBJECTIVEROM[rono].ROTHUMBIPFLEXIONAROMR !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].ROTHUMBIPFLEXIONAROML !== null) {
        thumbIPFxAROM = true;
    }

    if (state.entities.notes.PTOBJECTIVEROM[rono].ROTHUMBADDUCTIONAROMR !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].ROTHUMBADDUCTIONAROML !== null) {
        thumbAddAROM = true;
    }

    if (state.entities.notes.PTOBJECTIVEROM[rono].ROTHUMBABDUCTIONAROMR !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].ROTHUMBABDUCTIONAROML !== null) {
        thumbAbdAROM = true;
    }

    if (state.entities.notes.PTOBJECTIVEROM[rono].RODIGITOPPOSITIONAROMR !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].RODIGITOPPOSITIONAROML !== null) {
        DigitOppAROM = true;
    }





    let indexPROM = false;
    let middlePROM = false;
    let ringPROM = false;
    let smallPROM = false;
    let thumbPROM = false;
    let thumbMCPExPROM = false;
    let thumbMCPFxPROM = false;
    let thumbIPExPROM = false;
    let thumbIPFxPROM = false;
    let thumbAddPROM = false;
    let thumbAbdPROM = false;
    let DigitOppPROM = false;

    if (state.entities.notes.PTOBJECTIVEROM[rono].ROINDEXMCPEXTENSIONPROMR !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].ROINDEXMCPFLEXIONPROMR !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].ROINDEXMCPEXTENSIONPROML !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].ROINDEXMCPFLEXIONPROML !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].ROINDEXPIPEXTENSIONPROMR !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].ROINDEXPIPFLEXIONPROMR !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].ROINDEXPIPEXTENSIONPROML !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].ROINDEXPIPFLEXIONPROML !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].ROINDEXDIPEXTENSIONPROMR !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].ROINDEXDIPFLEXIONPROMR !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].ROINDEXDIPEXTENSIONPROML !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].ROINDEXDIPFLEXIONPROML !== null) {
        indexPROM = true;
    }

    if (state.entities.notes.PTOBJECTIVEROM[rono].ROMIDDLEMCPEXTENSIONPROMR !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].ROMIDDLEMCPFLEXIONPROMR !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].ROMIDDLEMCPEXTENSIONPROML !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].ROMIDDLEMCPFLEXIONPROML !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].ROMIDDLEPIPEXTENSIONPROMR !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].ROMIDDLEPIPFLEXIONPROMR !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].ROMIDDLEPIPEXTENSIONPROML !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].ROMIDDLEPIPFLEXIONPROML !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].ROMIDDLEDIPEXTENSIONPROMR !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].ROMIDDLEDIPFLEXIONPROMR !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].ROMIDDLEDIPEXTENSIONPROML !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].ROMIDDLEDIPFLEXIONPROML !== null) {
        middlePROM = true;
    }

    if (state.entities.notes.PTOBJECTIVEROM[rono].RORINGMCPEXTENSIONPROMR !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].RORINGMCPFLEXIONPROMR !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].RORINGMCPEXTENSIONPROML !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].RORINGMCPFLEXIONPROML !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].RORINGPIPEXTENSIONPROMR !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].RORINGPIPFLEXIONPROMR !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].RORINGPIPEXTENSIONPROML !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].RORINGPIPFLEXIONPROML !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].RORINGDIPEXTENSIONPROMR !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].RORINGDIPFLEXIONPROMR !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].RORINGDIPEXTENSIONPROML !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].RORINGDIPFLEXIONPROML !== null) {
        ringPROM = true;
    }

    if (state.entities.notes.PTOBJECTIVEROM[rono].ROSMALLMCPEXTENSIONPROMR !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].ROSMALLMCPFLEXIONPROMR !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].ROSMALLMCPEXTENSIONPROML !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].ROSMALLMCPFLEXIONPROML !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].ROSMALLPIPEXTENSIONPROMR !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].ROSMALLPIPFLEXIONPROMR !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].ROSMALLPIPEXTENSIONPROML !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].ROSMALLPIPFLEXIONPROML !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].ROSMALLDIPEXTENSIONPROMR !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].ROSMALLDIPFLEXIONPROMR !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].ROSMALLDIPEXTENSIONPROML !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].ROSMALLDIPFLEXIONPROML !== null) {
        smallPROM = true;
    }

    if (state.entities.notes.PTOBJECTIVEROM[rono].ROTHUMBMCPEXTENSIONPROMR !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].ROTHUMBMCPEXTENSIONPROML !== null) {
        thumbMCPExPROM = true;
    }
    if (state.entities.notes.PTOBJECTIVEROM[rono].ROTHUMBMCPFLEXIONPROMR !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].ROTHUMBMCPFLEXIONPROML !== null) {
        thumbMCPFxPROM = true;
    }

    if (state.entities.notes.PTOBJECTIVEROM[rono].ROTHUMBIPEXTENSIONPROMR !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].ROTHUMBIPEXTENSIONPROML !== null) {
        thumbIPExPROM = true;
    }
    if (state.entities.notes.PTOBJECTIVEROM[rono].ROTHUMBIPFLEXIONPROMR !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].ROTHUMBIPFLEXIONPROML !== null) {
        thumbIPFxPROM = true;
    }

    if (state.entities.notes.PTOBJECTIVEROM[rono].ROTHUMBADDUCTIONPROMR !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].ROTHUMBADDUCTIONPROML !== null) {
        thumbAddPROM = true;
    }

    if (state.entities.notes.PTOBJECTIVEROM[rono].ROTHUMBABDUCTIONPROMR !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].ROTHUMBABDUCTIONPROML !== null) {
        thumbAbdPROM = true;
    }

    if (state.entities.notes.PTOBJECTIVEROM[rono].RODIGITOPPOSITIONPROMR !== null
        || state.entities.notes.PTOBJECTIVEROM[rono].RODIGITOPPOSITIONPROML !== null) {
        DigitOppPROM = true;
    }

    let prevThumbAdductionPromR = '';
    let prevThumbAdductionPromL = '';
    let prevThumbAbductionPromR = '';
    let prevThumbAbductionPromL = '';
    let prevDigitOppositionPromR = '';
    let prevDigitOppositionPromL = '';

    let prevRingMcExtensionPromR = '';
    let prevRingMcpFlexionPromR = '';
    let prevRingMcExtensionPromL = '';
    let prevRingMcpFlexionPromL = '';
    let prevRingPipExtensionPromR = '';
    let prevRingPipFlexionPromR = '';
    let prevRingPipExtensionPromL = '';
    let prevRingPipFlexionPromL = '';
    let prevRingDipExtensionPromR = '';
    let prevRingDipFlexionPromR = '';
    let prevRingDipExtensionPromL = '';
    let prevRingDipFlexionPromL = '';

    let prevSmallMcExtensionPromR = '';
    let prevSmallMcpFlexionPromR = '';
    let prevSmallMcExtensionPromL = '';
    let prevSmallMcpFlexionPromL = '';
    let prevSmallPipExtensionPromR = '';
    let prevSmallPipFlexionPromR = '';
    let prevSmallPipExtensionPromL = '';
    let prevSmallPipFlexionPromL = '';
    let prevSmallDipExtensionPromR = '';
    let prevSmallDipFlexionPromR = '';
    let prevSmallDipExtensionPromL = '';
    let prevSmallDipFlexionPromL = '';

    let prevThumbMcpExtensionPromR = '';
    let prevThumbMcpExtensionPromL = '';
    let prevThumbMcpFlexionPromR = '';
    let prevThumbMcpFlexionPromL = '';
    let prevThumbIpExtensionPromR = '';
    let prevThumbIpExtensionPromL = '';
    let prevThumbIpFlexionPromR = '';
    let prevThumbIpFlexionPromL = '';

    let prevRingMcExtensionAromR = '';
    let prevRingMcpFlexionAromR = '';
    let prevRingMcExtensionAromL = '';
    let prevRingMcpFlexionAromL = '';
    let prevRingPipExtensionAromR = '';
    let prevRingPipFlexionAromR = '';
    let prevRingPipExtensionAromL = '';
    let prevRingPipFlexionAromL = '';
    let prevRingDipExtensionAromR = '';
    let prevRingDipFlexionAromR = '';
    let prevRingDipExtensionAromL = '';
    let prevRingDipFlexionAromL = '';

    let prevSmallMcExtensionAromR = '';
    let prevSmallMcpFlexionAromR = '';
    let prevSmallMcExtensionAromL = '';
    let prevSmallMcpFlexionAromL = '';
    let prevSmallPipExtensionAromR = '';
    let prevSmallPipFlexionAromR = '';
    let prevSmallPipExtensionAromL = '';
    let prevSmallPipFlexionAromL = '';
    let prevSmallDipExtensionAromR = '';
    let prevSmallDipFlexionAromR = '';
    let prevSmallDipExtensionAromL = '';
    let prevSmallDipFlexionAromL = '';

    let prevThumbMcExtensionAromR = '';
    let prevThumbMcExtensionAromL = '';
    let prevThumbMcpFlexionAromR = '';
    let prevThumbMcpFlexionAromL = '';
    let prevThumbIpExtensionAromR = '';
    let prevThumbIpExtensionAromL = '';
    let prevThumbIpFlexionAromR = '';
    let prevThumbIpFlexionAromL = '';
    let prevThumbAdductionAromR = '';
    let prevThumbAdductionAromL = '';
    let prevThumbAbductionAromR = '';
    let prevThumbAbductionAromL = '';
    let prevDigitOppositionAromR = '';
    let prevDigitOppositionAromL = '';

    let prevIndexMcExtensionPromR = '';
    let prevIndexMcpFlexionPromR = '';
    let prevIndexMcExtensionPromL = '';
    let prevIndexMcpFlexionPromL = '';
    let prevIndexPipExtensionPromR = '';
    let prevIndexPipFlexionPromR = '';
    let prevIndexPipExtensionPromL = '';
    let prevIndexPipFlexionPromL = '';
    let prevIndexDipExtensionPromR = '';
    let prevIndexDipFlexionPromR = '';
    let prevIndexDipExtensionPromL = '';
    let prevIndexDipFlexionPromL = '';

    let prevMiddleMcExtensionPromR = '';
    let prevMiddleMcpFlexionPromR = '';
    let prevMiddleMcExtensionPromL = '';
    let prevMiddleMcpFlexionPromL = '';
    let prevMiddlePipExtensionPromR = '';
    let prevMiddlePipFlexionPromR = '';
    let prevMiddlePipExtensionPromL = '';
    let prevMiddlePipFlexionPromL = '';
    let prevMiddleDipExtensionPromR = '';
    let prevMiddleDipFlexionPromR = '';
    let prevMiddleDipExtensionPromL = '';
    let prevMiddleDipFlexionPromL = '';

    let prevIndexMcExtensionAromR = '';
    let prevIndexMcpFlexionAromR = '';
    let prevIndexMcExtensionAromL = '';
    let prevIndexMcpFlexionAromL = '';
    let prevIndexPipExtensionAromR = '';
    let prevIndexPipFlexionAromR = '';
    let prevIndexPipExtensionAromL = '';
    let prevIndexPipFlexionAromL = '';
    let prevIndexDipExtensionAromR = '';
    let prevIndexDipFlexionAromR = '';
    let prevIndexDipExtensionAromL = '';
    let prevIndexDipFlexionAromL = '';

    let prevMiddleMcExtensionAromR = '';
    let prevMiddleMcpFlexionAromR = '';
    let prevMiddleMcExtensionAromL = '';
    let prevMiddleMcpFlexionAromL = '';
    let prevMiddlePipExtensionAromR = '';
    let prevMiddlePipFlexionAromR = '';
    let prevMiddlePipExtensionAromL = '';
    let prevMiddlePipFlexionAromL = '';
    let prevMiddleDipExtensionAromR = '';
    let prevMiddleDipFlexionAromR = '';
    let prevMiddleDipExtensionAromL = '';
    let prevMiddleDipFlexionAromL = '';

    if (state.entities.notes.PTOBJECTIVEROMPREV[pk]) {
        prevThumbAdductionPromR = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROTHUMBADDUCTIONPROMR'];
        prevThumbAdductionPromL = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROTHUMBADDUCTIONPROML'];
        prevThumbAbductionPromR = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROTHUMBABDUCTIONPROMR'];
        prevThumbAbductionPromL = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROTHUMBABDUCTIONPROML'];
        prevDigitOppositionPromR = state.entities.notes.PTOBJECTIVEROMPREV[pk]['RODIGITOPPOSITIONPROMR'];
        prevDigitOppositionPromL = state.entities.notes.PTOBJECTIVEROMPREV[pk]['RODIGITOPPOSITIONPROML'];

        prevIndexMcExtensionAromR = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROINDEXMCPEXTENSIONAROMR'];
        prevIndexMcpFlexionAromR = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROINDEXMCPFLEXIONAROMR'];
        prevIndexMcExtensionAromL = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROINDEXMCPEXTENSIONAROML'];
        prevIndexMcpFlexionAromL = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROINDEXMCPFLEXIONAROML'];
        prevIndexPipExtensionAromR = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROINDEXPIPEXTENSIONAROMR'];
        prevIndexPipFlexionAromR = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROINDEXPIPFLEXIONAROMR'];
        prevIndexPipExtensionAromL = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROINDEXPIPEXTENSIONAROML'];
        prevIndexPipFlexionAromL = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROINDEXPIPFLEXIONAROML'];
        prevIndexDipExtensionAromR = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROINDEXDIPEXTENSIONAROMR'];
        prevIndexDipFlexionAromR = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROINDEXDIPFLEXIONAROMR'];
        prevIndexDipExtensionAromL = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROINDEXDIPEXTENSIONAROML'];
        prevIndexDipFlexionAromL = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROINDEXDIPFLEXIONAROML'];

        prevMiddleMcExtensionAromR = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROMIDDLEMCPEXTENSIONAROMR'];
        prevMiddleMcpFlexionAromR = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROMIDDLEMCPFLEXIONAROMR'];
        prevMiddleMcExtensionAromL = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROMIDDLEMCPEXTENSIONAROML'];
        prevMiddleMcpFlexionAromL = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROMIDDLEMCPFLEXIONAROML'];
        prevMiddlePipExtensionAromR = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROMIDDLEPIPEXTENSIONAROMR'];
        prevMiddlePipFlexionAromR = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROMIDDLEPIPFLEXIONAROMR'];
        prevMiddlePipExtensionAromL = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROMIDDLEPIPEXTENSIONAROML'];
        prevMiddlePipFlexionAromL = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROMIDDLEPIPFLEXIONAROML'];
        prevMiddleDipExtensionAromR = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROMIDDLEDIPEXTENSIONAROMR'];
        prevMiddleDipFlexionAromR = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROMIDDLEDIPFLEXIONAROMR'];
        prevMiddleDipExtensionAromL = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROMIDDLEDIPEXTENSIONAROML'];
        prevMiddleDipFlexionAromL = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROMIDDLEDIPFLEXIONAROML'];

        prevIndexMcExtensionPromR = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROINDEXMCPEXTENSIONPROMR'];
        prevIndexMcpFlexionPromR = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROINDEXMCPFLEXIONPROMR'];
        prevIndexMcExtensionPromL = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROINDEXMCPEXTENSIONPROML'];
        prevIndexMcpFlexionPromL = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROINDEXMCPFLEXIONPROML'];
        prevIndexPipExtensionPromR = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROINDEXPIPEXTENSIONPROMR'];
        prevIndexPipFlexionPromR = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROINDEXPIPFLEXIONPROMR'];
        prevIndexPipExtensionPromL = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROINDEXPIPEXTENSIONPROML'];
        prevIndexPipFlexionPromL = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROINDEXPIPFLEXIONPROML'];
        prevIndexDipExtensionPromR = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROINDEXDIPEXTENSIONPROMR'];
        prevIndexDipFlexionPromR = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROINDEXDIPFLEXIONPROMR'];
        prevIndexDipExtensionPromL = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROINDEXDIPEXTENSIONPROML'];
        prevIndexDipFlexionPromL = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROINDEXDIPFLEXIONPROML'];

        prevMiddleMcExtensionPromR = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROMIDDLEMCPEXTENSIONPROMR'];
        prevMiddleMcpFlexionPromR = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROMIDDLEMCPFLEXIONPROMR'];
        prevMiddleMcExtensionPromL = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROMIDDLEMCPEXTENSIONPROML'];
        prevMiddleMcpFlexionPromL = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROMIDDLEMCPFLEXIONPROML'];
        prevMiddlePipExtensionPromR = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROMIDDLEPIPEXTENSIONPROMR'];
        prevMiddlePipFlexionPromR = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROMIDDLEPIPFLEXIONPROMR'];
        prevMiddlePipExtensionPromL = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROMIDDLEPIPEXTENSIONPROML'];
        prevMiddlePipFlexionPromL = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROMIDDLEPIPFLEXIONPROML'];
        prevMiddleDipExtensionPromR = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROMIDDLEDIPEXTENSIONPROMR'];
        prevMiddleDipFlexionPromR = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROMIDDLEDIPFLEXIONPROMR'];
        prevMiddleDipExtensionPromL = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROMIDDLEDIPEXTENSIONPROML'];
        prevMiddleDipFlexionPromL = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROMIDDLEDIPFLEXIONPROML'];

        prevRingMcExtensionAromR = state.entities.notes.PTOBJECTIVEROMPREV[pk]['RORINGMCPEXTENSIONAROMR'];
        prevRingMcpFlexionAromR = state.entities.notes.PTOBJECTIVEROMPREV[pk]['RORINGMCPFLEXIONAROMR'];
        prevRingMcExtensionAromL = state.entities.notes.PTOBJECTIVEROMPREV[pk]['RORINGMCPEXTENSIONAROML'];
        prevRingMcpFlexionAromL = state.entities.notes.PTOBJECTIVEROMPREV[pk]['RORINGMCPFLEXIONAROML'];
        prevRingPipExtensionAromR = state.entities.notes.PTOBJECTIVEROMPREV[pk]['RORINGPIPEXTENSIONAROMR'];
        prevRingPipFlexionAromR = state.entities.notes.PTOBJECTIVEROMPREV[pk]['RORINGPIPFLEXIONAROMR'];
        prevRingPipExtensionAromL = state.entities.notes.PTOBJECTIVEROMPREV[pk]['RORINGPIPEXTENSIONAROML'];
        prevRingPipFlexionAromL = state.entities.notes.PTOBJECTIVEROMPREV[pk]['RORINGPIPFLEXIONAROML'];
        prevRingDipExtensionAromR = state.entities.notes.PTOBJECTIVEROMPREV[pk]['RORINGDIPEXTENSIONAROMR'];
        prevRingDipFlexionAromR = state.entities.notes.PTOBJECTIVEROMPREV[pk]['RORINGDIPFLEXIONAROMR'];
        prevRingDipExtensionAromL = state.entities.notes.PTOBJECTIVEROMPREV[pk]['RORINGDIPEXTENSIONAROML'];
        prevRingDipFlexionAromL = state.entities.notes.PTOBJECTIVEROMPREV[pk]['RORINGDIPFLEXIONAROML'];

        prevSmallMcExtensionAromR = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROSMALLMCPEXTENSIONAROMR'];
        prevSmallMcpFlexionAromR = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROSMALLMCPFLEXIONAROMR'];
        prevSmallMcExtensionAromL = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROSMALLMCPEXTENSIONAROML'];
        prevSmallMcpFlexionAromL = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROSMALLMCPFLEXIONAROML'];
        prevSmallPipExtensionAromR = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROSMALLPIPEXTENSIONAROMR'];
        prevSmallPipFlexionAromR = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROSMALLPIPFLEXIONAROMR'];
        prevSmallPipExtensionAromL = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROSMALLPIPEXTENSIONAROML'];
        prevSmallPipFlexionAromL = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROSMALLPIPFLEXIONAROML'];
        prevSmallDipExtensionAromR = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROSMALLDIPEXTENSIONAROMR'];
        prevSmallDipFlexionAromR = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROSMALLDIPFLEXIONAROMR'];
        prevSmallDipExtensionAromL = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROSMALLDIPEXTENSIONAROML'];
        prevSmallDipFlexionAromL = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROSMALLDIPFLEXIONAROML'];

        prevThumbMcExtensionAromR = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROTHUMBMCPEXTENSIONAROMR'];
        prevThumbMcExtensionAromL = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROTHUMBMCPEXTENSIONAROML'];
        prevThumbMcpFlexionAromR = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROTHUMBMCPFLEXIONAROMR'];
        prevThumbMcpFlexionAromL = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROTHUMBMCPFLEXIONAROML'];
        prevThumbIpExtensionAromR = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROTHUMBIPEXTENSIONAROMR'];
        prevThumbIpExtensionAromL = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROTHUMBIPEXTENSIONAROML'];
        prevThumbIpFlexionAromR = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROTHUMBIPFLEXIONAROMR'];
        prevThumbIpFlexionAromL = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROTHUMBIPFLEXIONAROML'];
        prevThumbAdductionAromR = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROTHUMBADDUCTIONAROMR'];
        prevThumbAdductionAromL = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROTHUMBADDUCTIONAROML'];
        prevThumbAbductionAromR = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROTHUMBABDUCTIONAROMR'];
        prevThumbAbductionAromL = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROTHUMBABDUCTIONAROML'];
        prevDigitOppositionAromR = state.entities.notes.PTOBJECTIVEROMPREV[pk]['RODIGITOPPOSITIONAROMR'];
        prevDigitOppositionAromL = state.entities.notes.PTOBJECTIVEROMPREV[pk]['RODIGITOPPOSITIONAROML'];

        prevRingMcExtensionPromR = state.entities.notes.PTOBJECTIVEROMPREV[pk]['RORINGMCPEXTENSIONPROMR'];
        prevRingMcpFlexionPromR = state.entities.notes.PTOBJECTIVEROMPREV[pk]['RORINGMCPFLEXIONPROMR'];
        prevRingMcExtensionPromL = state.entities.notes.PTOBJECTIVEROMPREV[pk]['RORINGMCPEXTENSIONPROML'];
        prevRingMcpFlexionPromL = state.entities.notes.PTOBJECTIVEROMPREV[pk]['RORINGMCPFLEXIONPROML'];
        prevRingPipExtensionPromR = state.entities.notes.PTOBJECTIVEROMPREV[pk]['RORINGPIPEXTENSIONPROMR'];
        prevRingPipFlexionPromR = state.entities.notes.PTOBJECTIVEROMPREV[pk]['RORINGPIPFLEXIONPROMR'];
        prevRingPipExtensionPromL = state.entities.notes.PTOBJECTIVEROMPREV[pk]['RORINGPIPEXTENSIONPROML'];
        prevRingPipFlexionPromL = state.entities.notes.PTOBJECTIVEROMPREV[pk]['RORINGPIPFLEXIONPROML'];
        prevRingDipExtensionPromR = state.entities.notes.PTOBJECTIVEROMPREV[pk]['RORINGDIPEXTENSIONPROMR'];
        prevRingDipFlexionPromR = state.entities.notes.PTOBJECTIVEROMPREV[pk]['RORINGDIPFLEXIONPROMR'];
        prevRingDipExtensionPromL = state.entities.notes.PTOBJECTIVEROMPREV[pk]['RORINGDIPEXTENSIONPROML'];
        prevRingDipFlexionPromL = state.entities.notes.PTOBJECTIVEROMPREV[pk]['RORINGDIPFLEXIONPROML'];

        prevSmallMcExtensionPromR = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROSMALLMCPEXTENSIONPROMR'];
        prevSmallMcpFlexionPromR = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROSMALLMCPFLEXIONPROMR'];
        prevSmallMcExtensionPromL = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROSMALLMCPEXTENSIONPROML'];
        prevSmallMcpFlexionPromL = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROSMALLMCPFLEXIONPROML'];
        prevSmallPipExtensionPromR = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROSMALLPIPEXTENSIONPROMR'];
        prevSmallPipFlexionPromR = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROSMALLPIPFLEXIONPROMR'];
        prevSmallPipExtensionPromL = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROSMALLPIPEXTENSIONPROML'];
        prevSmallPipFlexionPromL = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROSMALLPIPFLEXIONPROML'];
        prevSmallDipExtensionPromR = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROSMALLDIPEXTENSIONPROMR'];
        prevSmallDipFlexionPromR = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROSMALLDIPFLEXIONPROMR'];
        prevSmallDipExtensionPromL = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROSMALLDIPEXTENSIONPROML'];
        prevSmallDipFlexionPromL = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROSMALLDIPFLEXIONPROML'];

        prevThumbMcpExtensionPromR = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROTHUMBMCPEXTENSIONPROMR'];
        prevThumbMcpExtensionPromL = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROTHUMBMCPEXTENSIONPROML'];
        prevThumbMcpFlexionPromR = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROTHUMBMCPFLEXIONPROMR'];
        prevThumbMcpFlexionPromL = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROTHUMBMCPFLEXIONPROML'];
        prevThumbIpExtensionPromR = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROTHUMBIPEXTENSIONPROMR'];
        prevThumbIpExtensionPromL = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROTHUMBIPEXTENSIONPROML'];
        prevThumbIpFlexionPromR = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROTHUMBIPFLEXIONPROMR'];
        prevThumbIpFlexionPromL = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROTHUMBIPFLEXIONPROML'];
    }

    if (state.entities.notes.PTOBJECTIVEROM[rono].ROMCPROVISIONALCLASS) {
        flagged = true;
    }

    return {
        noteType,
        pk,
        noteId: noteId,
        rono: rono,
        flagged: flagged,
        indexAROM,
        middleAROM,
        ringAROM,
        smallAROM,
        thumbMCPExAROM,
        thumbMCPFxAROM,
        thumbIPExAROM,
        thumbIPFxAROM,
        thumbAddAROM,
        thumbAbdAROM,
        indexPROM,
        middlePROM,
        ringPROM,
        smallPROM,
        thumbMCPExPROM,
        thumbMCPFxPROM,
        thumbIPExPROM,
        thumbIPFxPROM,
        thumbAddPROM,
        thumbAbdPROM,
        DigitOppPROM,
        DigitOppAROM,
        prevThumbAdductionPromR,
        prevThumbAdductionPromL,
        prevThumbAbductionPromR,
        prevThumbAbductionPromL,
        prevDigitOppositionPromR,
        prevDigitOppositionPromL,
        prevRingMcExtensionPromR,
        prevRingMcpFlexionPromR,
        prevRingMcExtensionPromL,
        prevRingMcpFlexionPromL,
        prevRingPipExtensionPromR,
        prevRingPipFlexionPromR,
        prevRingPipExtensionPromL,
        prevRingPipFlexionPromL,
        prevRingDipExtensionPromR,
        prevRingDipFlexionPromR,
        prevRingDipExtensionPromL,
        prevRingDipFlexionPromL,
        prevSmallMcExtensionPromR,
        prevSmallMcpFlexionPromR,
        prevSmallMcExtensionPromL,
        prevSmallMcpFlexionPromL,
        prevSmallPipExtensionPromR,
        prevSmallPipFlexionPromR,
        prevSmallPipExtensionPromL,
        prevSmallPipFlexionPromL,
        prevSmallDipExtensionPromR,
        prevSmallDipFlexionPromR,
        prevSmallDipExtensionPromL,
        prevSmallDipFlexionPromL,
        prevThumbMcpExtensionPromR,
        prevThumbMcpExtensionPromL,
        prevThumbMcpFlexionPromR,
        prevThumbMcpFlexionPromL,
        prevThumbIpExtensionPromR,
        prevThumbIpExtensionPromL,
        prevThumbIpFlexionPromR,
        prevThumbIpFlexionPromL,
        prevRingMcExtensionAromR,
        prevRingMcpFlexionAromR,
        prevRingMcExtensionAromL,
        prevRingMcpFlexionAromL,
        prevRingPipExtensionAromR,
        prevRingPipFlexionAromR,
        prevRingPipExtensionAromL,
        prevRingPipFlexionAromL,
        prevRingDipExtensionAromR,
        prevRingDipFlexionAromR,
        prevRingDipExtensionAromL,
        prevRingDipFlexionAromL,
        prevSmallMcExtensionAromR,
        prevSmallMcpFlexionAromR,
        prevSmallMcExtensionAromL,
        prevSmallMcpFlexionAromL,
        prevSmallPipExtensionAromR,
        prevSmallPipFlexionAromR,
        prevSmallPipExtensionAromL,
        prevSmallPipFlexionAromL,
        prevSmallDipExtensionAromR,
        prevSmallDipFlexionAromR,
        prevSmallDipExtensionAromL,
        prevSmallDipFlexionAromL,
        prevThumbMcExtensionAromR,
        prevThumbMcExtensionAromL,
        prevThumbMcpFlexionAromR,
        prevThumbMcpFlexionAromL,
        prevThumbIpExtensionAromR,
        prevThumbIpExtensionAromL,
        prevThumbIpFlexionAromR,
        prevThumbIpFlexionAromL,
        prevThumbAdductionAromR,
        prevThumbAdductionAromL,
        prevThumbAbductionAromR,
        prevThumbAbductionAromL,
        prevDigitOppositionAromR,
        prevDigitOppositionAromL,
        prevIndexMcExtensionPromR,
        prevIndexMcpFlexionPromR,
        prevIndexMcExtensionPromL,
        prevIndexMcpFlexionPromL,
        prevIndexPipExtensionPromR,
        prevIndexPipFlexionPromR,
        prevIndexPipExtensionPromL,
        prevIndexPipFlexionPromL,
        prevIndexDipExtensionPromR,
        prevIndexDipFlexionPromR,
        prevIndexDipExtensionPromL,
        prevIndexDipFlexionPromL,
        prevMiddleMcExtensionPromR,
        prevMiddleMcpFlexionPromR,
        prevMiddleMcExtensionPromL,
        prevMiddleMcpFlexionPromL,
        prevMiddlePipExtensionPromR,
        prevMiddlePipFlexionPromR,
        prevMiddlePipExtensionPromL,
        prevMiddlePipFlexionPromL,
        prevMiddleDipExtensionPromR,
        prevMiddleDipFlexionPromR,
        prevMiddleDipExtensionPromL,
        prevMiddleDipFlexionPromL,
        prevIndexMcExtensionAromR,
        prevIndexMcpFlexionAromR,
        prevIndexMcExtensionAromL,
        prevIndexMcpFlexionAromL,
        prevIndexPipExtensionAromR,
        prevIndexPipFlexionAromR,
        prevIndexPipExtensionAromL,
        prevIndexPipFlexionAromL,
        prevIndexDipExtensionAromR,
        prevIndexDipFlexionAromR,
        prevIndexDipExtensionAromL,
        prevIndexDipFlexionAromL,
        prevMiddleMcExtensionAromR,
        prevMiddleMcpFlexionAromR,
        prevMiddleMcExtensionAromL,
        prevMiddleMcpFlexionAromL,
        prevMiddlePipExtensionAromR,
        prevMiddlePipFlexionAromR,
        prevMiddlePipExtensionAromL,
        prevMiddlePipFlexionAromL,
        prevMiddleDipExtensionAromR,
        prevMiddleDipFlexionAromR,
        prevMiddleDipExtensionAromL,
        prevMiddleDipFlexionAromL,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        updateDefaultObjHandWFL: bindActionCreators(noteActions.updateDefaultObjHandWFL, dispatch),
    };
}

const connectedROMHandTemplate = connect(mapStateToProps, mapDispatchToProps)(ROMHandTemplate);
export { connectedROMHandTemplate as ROMHandTemplate };


